<template>
    <div class="page-wrapper">
        <div class="main-content-grid" :style="{ gridTemplateColumns: $route.meta.hideNav ? '1fr' : '112px 1fr' }">
            <LeftSidebar v-if="!$route.meta.hideNav" />
            <div class="main-scroll-area">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
import LeftSidebar from '@/components/LeftSidebar.vue'

export default {
    name: 'MainLayout',
    components: { LeftSidebar }
}
</script>

<style>
.page-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: 0 auto;
    background-color: white;
}


.main-content-grid {
    flex: 1 1 auto;
    display: grid;
    grid-template-columns: 112px 1fr;
    height: 100%;
    min-height: 0;
}

.main-scroll-area {
    height: 100vh;
    overflow-y: auto;
    min-width: 0;
    min-height: 0;
}

audio {
    background: transparent !important;
}

audio::-webkit-media-controls-enclosure,
audio::-webkit-media-controls-panel {
    background-color: transparent !important;
}

audio::-moz-media-controls-panel {
    background-color: transparent !important;
}
</style>
